export const formatTonnes = (tonnes: number | string, maximumFractionDigits = 0): string => {
  if (typeof tonnes === 'string') {
    return formatTonnes(Number.parseFloat(tonnes), maximumFractionDigits);
  }
  return `${tonnes.toFixed(maximumFractionDigits)} MT`;
};
